// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-select[data-v-6bc90c80]{--input-height:38px;--line-height:16px;--font-size:14px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
